module.exports = __webpack_public_path__ + "static/media/mid-grade-supply.d9b192d9.jpg";